export default __webpack_public_path__ + "static/13-2e49988862dbee912edd8d7b0de0da42.png";